const WorkerHousingQuery = (id) => {
  return `
    query {
        getWorkerHousingById(id: "${id}") {
          id
          group_id,
          form_id,
          WorkerHousingFormData {
            new_profile_worker_housing_type_of_housing,
            new_profile_worker_housing_physical_location_address,
            new_profile_worker_housing_physical_location_city,
            new_profile_worker_housing_physical_location_state,
            new_profile_worker_housing_physical_location_county{
              label,
              value
            },
            new_profile_worker_housing_physical_location_zip_code,
            new_profile_worker_housing_additional_housing_information,
            new_profile_worker_housing_total_units,
            new_profile_worker_housing_total_occupancy,
            new_profile_worker_housing_applicable_housing_standards{
              value,
              label
            },
            new_profile_worker_housing_applicable_housing_standards_local,
            new_profile_worker_housing_applicable_housing_standards_swa,
            new_profile_worker_housing_applicable_housing_standards_other_state,
            new_profile_worker_housing_applicable_housing_standards_other,
            new_profile_worker_housing_applicable_housing_standards_federal,
            new_profile_worker_housing_applicable_housing_standards_other_text,
            new_profile_worker_housing_profile_name
        }
        }
      }
      `;
};

export const WorkerHousingsQuery = (id) => {
  return `
    query {
        getWorkerHousingByIds(ids: ${id}) {
          id
          group_id,
          form_id,
          WorkerHousingFormData {
            new_profile_worker_housing_type_of_housing,
            new_profile_worker_housing_physical_location_address,
            new_profile_worker_housing_physical_location_city,
            new_profile_worker_housing_physical_location_state,
            new_profile_worker_housing_physical_location_county{
              label,
              value
            },
            new_profile_worker_housing_physical_location_zip_code,
            new_profile_worker_housing_additional_housing_information,
            new_profile_worker_housing_total_units,
            new_profile_worker_housing_total_occupancy,
            new_profile_worker_housing_applicable_housing_standards{
              value,
              label
            },
            new_profile_worker_housing_applicable_housing_standards_local,
            new_profile_worker_housing_applicable_housing_standards_swa,
            new_profile_worker_housing_applicable_housing_standards_other_state,
            new_profile_worker_housing_applicable_housing_standards_other,
            new_profile_worker_housing_applicable_housing_standards_federal,
            new_profile_worker_housing_applicable_housing_standards_other_text,
            new_profile_worker_housing_profile_name,
            error
        }
        }
      }
      `;
};

export default WorkerHousingQuery;
